export default __webpack_public_path__ + "static/media/cross.c641c7eb.svg";